import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';
import { Navigate } from 'react-router-dom';
import { useMode } from '../hooks/useMode';
import { SHARED_ROUTES } from '../routes';

export const IntroductionRedirect = () => {
  const mode = useMode();
  const selectedProfessional = useSelector(
    (state: RootState) => state.consultation?.professional,
  );
  const selectedPractice = useSelector(
    (state: RootState) => state.consultation?.practice,
  );
  const noAppointment = useSelector(
    (state: RootState) => state.consultation.noAppointment,
  );

  if (mode?.includes('LINK') && selectedProfessional?.slug)
    return <Navigate to={`/professional/${selectedProfessional.slug}`} />;
  else if (mode === 'INVITATION' && selectedPractice) {
    if (noAppointment) return <Navigate to={SHARED_ROUTES.ERROR} />; // TODO: add noAppointment page
    return <Navigate to={SHARED_ROUTES.LANDING_PAGE} />;
  }
  return <Navigate to={SHARED_ROUTES.ERROR} />;
};
